export interface AutocompleteOption {
  label: string;
  value: string;
  labelClassName?: string;
  radioButtonClassName?: string;
  radioButtonContainerClassName?: string;
  children?: React.ReactNode;
}
export interface AutocompleteRecord {
  following?: boolean;
  label: string;
  value: number;
}

export interface SuccessResponse {
  success: boolean;
  message?: string;
}

export interface PageParams {
  page: number;
  perPage: number;
}

export interface PagedResponse {
  hasNextPage: boolean;
  nextPage: number;
  page: number;
  totalCount: number;
  totalPages: number;
}

export interface CreateRecordResponse extends SuccessResponse {
  id: number;
}

export enum GtagEvents {
  CONVERSION = 'conversion',
  GENERATELEAD = 'generate_lead_native',
  PURCHASE = 'purchase',
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  CBPT = 'canceled_but_paid_through',
  LEAD = 'never_added_payment_info',
  PAST_DUE = 'past_due',
  TRIALING = 'trialing',
}

export enum SubscriptionPlanType {
  Annual = 'yearly',
  Monthly = 'monthly',
  Pro = 'pro',
  Ticker = 'ticker',
  YoungProfessional = 'yp',
}
